import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const LibraShape = ({
  width = 40,
  height = 40,
  fillColor = '#FFF',
  style
}: BaseSVGType) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <g id="Layer_2" data-name="Layer 2">
      <g id="Horoscope" fill={fillColor}>
        <g>
          <path d="M4,35H16.2a2.1,2.1,0,0,0,2-1.5,2.2,2.2,0,0,0-.9-2.2A12.9,12.9,0,0,1,11,20.1a13,13,0,1,1,26,0,12.9,12.9,0,0,1-6.3,11.2,2.2,2.2,0,0,0-.9,2.2,2.1,2.1,0,0,0,2,1.5H44a2,2,0,0,0,0-4H37.1a17,17,0,1,0-26.2,0H4a2,2,0,0,0,0,4Z" />
          <path d="M44,39H4a2,2,0,0,0,0,4H44a2,2,0,0,0,0-4Z" />
        </g>
      </g>
    </g>
  </svg>
);

export default LibraShape;
